
  import { commonModule, companyModule } from '@/store/modules/store-accessor'
  import Vue from "vue";
  import { Component, Prop, Watch } from "vue-property-decorator";
  import { dedupeAssigneesById } from "@/helpers/assignees";
  import { assigneeSearchFilter } from "@/helpers/data";
  
  @Component
  export default class AssigneeMultiUserCombo extends Vue {
    selectedAssignees = [] as any;
    assigneeIdCombo = [] as any;
    baseComboLength = 0; // combo size before any applySelectionFromDefaultAssignees unshifts

    @Prop({ default: () => ({}) }) defaultAssignees: any[]; // for edit modals & add appointment in the calendar page
    @Prop({ default: true }) rightMargin!: boolean; // will set it to false in the add job modal
    @Prop({ default: true }) groupSelected!: boolean;
    @Prop({ default: true }) selectAll!: boolean;
    @Prop({ default: false }) includePartners!: boolean;


    loading = true;
    assigneeSearchFilter = assigneeSearchFilter;

    selectEntry() {
      this.$emit('update-filter', this.selectedAssignees);
    }

    doSelectAll() {
      if (this.allOptionsSelectedFlag) {
        this.selectedAssignees = [];
      } else {
        this.selectedAssignees = [...this.assigneeIdCombo];
      }
      this.$emit('update-filter', this.selectedAssignees);
    }

    findComboItemForAssignee(assignee: any, combo: any[]) {
      const name = (assignee?.name ?? "").trim();
      const id = assignee?.id;
      if (id != null && id !== "") {
        const byId = combo.find((item: any) => String(item.id) === String(id));
        if (byId) return byId;
      }
      if (name) {
        return combo.find((item: any) => (item.name ?? "").trim() === name);
      }
      return undefined;
    }

    applySelectionFromDefaultAssignees(emitUpdate: boolean) {
      if (!this.defaultAssignees || !Array.isArray(this.defaultAssignees) || this.defaultAssignees.length === 0) {
        return;
      }
      const combo = this.assigneeIdCombo;
      this.selectedAssignees = this.defaultAssignees.map((assignee: any) => {
        const foundItem = this.findComboItemForAssignee(assignee, this.assigneeIdCombo);
        if (!foundItem) {
          const assignee_obj = {
            name: assignee?.name,
            id: assignee?.id,
            hidden_id: (Math.random() + 1).toString(36).substring(7),
          };
          this.assigneeIdCombo.unshift(assignee_obj);
          return assignee_obj;
        }
        return foundItem;
      });
      // deduplicate: same id+name pair is the same person, keep first occurrence only
      this.selectedAssignees = this.selectedAssignees.filter(
        (a: any, i: number, arr: any[]) => arr.findIndex((b: any) => b.id === a.id && b.name === a.name) === i
      );
      if (emitUpdate) {
        this.$emit("update-filter", this.selectedAssignees);
      }
    }

    async ensureAssigneeComboLoaded() {
      // Dedupe the combo by user id so the same person can never appear as two
      // selectable rows (e.g. a multi-role user returned once per role, each with
      // its own random hidden_id) — the cause of duplicate active_assignee errors.
      if (this.includePartners && companyModule.company?.modules?.includes("DFB_PORTAL_PARTNERS")) {
        await commonModule.getPersonnelPartnersCombo();
        this.assigneeIdCombo = dedupeAssigneesById(commonModule.personnelPartnersCombo);
      } else {
        await commonModule.getPersonnelCombo();
        this.assigneeIdCombo = dedupeAssigneesById(commonModule.personnelCombo);
      }
      this.baseComboLength = this.assigneeIdCombo.length;
    }

    @Watch("defaultAssignees", { deep: true })
    async onDefaultAssigneesChanged() {
      if (!this.assigneeIdCombo?.length) {
        await this.ensureAssigneeComboLoaded();
      }
      if (this.defaultAssignees && Array.isArray(this.defaultAssignees) && this.defaultAssignees.length > 0) {
        this.applySelectionFromDefaultAssignees(true);
      }
    }

    async mounted() {
      await this.ensureAssigneeComboLoaded();

      this.applySelectionFromDefaultAssignees(true);

      const noDefaults =
        !Array.isArray(this.defaultAssignees) || this.defaultAssignees.length === 0;
      if (!this.includePartners && noDefaults && this.assigneeIdCombo.length === 1) {
        this.selectedAssignees = [...this.assigneeIdCombo];
        this.$emit("update-filter", this.selectedAssignees);
      }

      this.loading = false;
    }

    rules = [
      (val: any) => (val.length > 0) || this.$i18n.t("user_required"),
    ]

    get allOptionsSelectedFlag(): boolean {
      return this.baseComboLength > 0 &&
        this.selectedAssignees.length >= this.baseComboLength;
    }

    get assigneeDropdownLabel() {
      if(this.includePartners && companyModule.company?.modules?.includes('DFB_PORTAL_PARTNERS')) {
        return this.$i18n.t('userPartner');
      }
      else {
        return this.$i18n.t('user');
      }
    }
  }
